var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0982 6.46154H18V8.30769H10.0982V6.46154Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.38462C6 6.61991 6.61161 6 7.36607 6C8.12053 6 8.73214 6.61991 8.73214 7.38462C8.73214 8.14932 8.12053 8.76923 7.36607 8.76923C6.61161 8.76923 6 8.14932 6 7.38462Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0982 11.0769H18V12.9231H10.0982V11.0769Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 11.2353 6.61161 10.6154 7.36607 10.6154C8.12053 10.6154 8.73214 11.2353 8.73214 12C8.73214 12.7647 8.12053 13.3846 7.36607 13.3846C6.61161 13.3846 6 12.7647 6 12Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0982 15.6923H18V17.5385H10.0982V15.6923Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.6154C6 15.8507 6.61161 15.2308 7.36607 15.2308C8.12053 15.2308 8.73214 15.8507 8.73214 16.6154C8.73214 17.3801 8.12053 18 7.36607 18C6.61161 18 6 17.3801 6 16.6154Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.632adf63773c2c29d5fa06b38251026c.svg";
export { ForwardRef as ReactComponent };